"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExampleRequest = function () {
	_createClass(ExampleRequest, null, [{
		key: "from",
		value: function from(request) {
			return new ExampleRequest(request);
		}
	}]);

	function ExampleRequest(request) {
		_classCallCheck(this, ExampleRequest);

		this.request = request;
	}

	_createClass(ExampleRequest, [{
		key: "method",
		get: function get() {
			return this.request.method;
		}
	}, {
		key: "url",
		get: function get() {
			return this.request.url;
		}
	}, {
		key: "headers",
		get: function get() {
			if (!this.request.headers) {
				return null;
			}
			// TODO: needs work
			var headers = {};
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = this.request.headers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var _ref = _step.value;
					var name = _ref.name,
					    value = _ref.value;

					headers[name] = value;
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return headers;
		}
	}, {
		key: "body",
		get: function get() {
			return this.request.body;
		}
	}]);

	return ExampleRequest;
}();

var _default = ExampleRequest;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(ExampleRequest, "ExampleRequest", "src/components/SwaggerUI/ExampleRequest.js");

	__REACT_HOT_LOADER__.register(_default, "default", "src/components/SwaggerUI/ExampleRequest.js");
}();

;